import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

import { onBeforeRoute, onRouteError } from './helpers';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => onBeforeRoute(to, from, next));

router.onError((error) => onRouteError(error));

export default router;
